import request from '@/utils/request';

const path = 'api/v1';


const tporderPost = data => request({
  url: `${path}/products/tporder`,
  method: 'POST',
  data,
});

const tporderList = data => request({
  url: `${path}/products/tporder`,
  method: 'Get',
  params: data,
});

const tporderPut = data => request({
  url: `${path}/products/tporder`,
  method: 'Put',
  data,
});

const tporderDelete = data => request({
  url: `${path}/products/tporder`,
  method: 'Delete',
  params: data,
});

const addBoxPut = data => request({
  url: `${path}/products/tporder/addBox`,
  method: 'Put',
  data,
});

const delBoxPut = data => request({
  url: `${path}/products/tporder/delBox`,
  method: 'Put',
  data,
});

const tporderDetail = data => request({
  url: `${path}/products/tporder/detail`,
  method: 'Get',
  params: data,
});

const caseDetailByProductOrderNo = data => request({
  url: `${path}/send/products/tporder/caseDetailByProductOrderNo`,
  method: 'Get',
  params: data,
});

const sendPut = data => request({
  url: `${path}/send/products/tporder`,
  method: 'Put',
  data,
});

const confirmPut = data => request({
  url: `${path}/confirm/products/tporder`,
  method: 'Put',
  data,
});

const addExpressageNo = data => request({
  url: `${path}/addExpressageNo/products/tporder`,
  method: 'Put',
  data,
});

export {
  tporderPost,
  tporderList,
  tporderPut,
  tporderDelete,
  addBoxPut,
  delBoxPut,
  tporderDetail,
  caseDetailByProductOrderNo,
  sendPut,
  confirmPut,
  addExpressageNo,
};
